import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GltfViewerComponent } from './gltf-viewer.component';

@NgModule({
    declarations: [
        GltfViewerComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        GltfViewerComponent
    ]
})
export class NcGltfViewerModule { }